import videoFile from '../../assets/video/video_2026-01-15_23-19-17.mp4';

function VideoSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 bg-gradient-to-r from-amber-500/5 via-transparent to-orange-500/5"></div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-500 text-transparent bg-clip-text">
              Watch How It Works
            </span>
          </h2>
          <p className="text-slate-300 text-lg md:text-xl max-w-3xl mx-auto">
            See firsthand how our credit control system transforms businesses
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-md mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-amber-500/20 border border-amber-500/20 bg-slate-800/50 backdrop-blur-sm">
            {/* Video Player */}
            <div className="relative">
              <video 
                className="w-full h-auto max-h-[80vh] object-contain"
                controls
                controlsList="nodownload"
                preload="metadata"
              >
                <source src={videoFile} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Decorative Border Glow */}
            <div className="absolute inset-0 rounded-2xl border-2 border-amber-500/30 pointer-events-none"></div>
          </div>

          {/* Optional Caption or CTA Below Video */}
          <div className="text-center mt-8">
            <p className="text-slate-400 text-sm md:text-base">
              Ready to transform your credit control? 
              <span className="text-amber-400 font-semibold ml-2">
                Start your journey today
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
